import React from "react";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";

import { contactCTAText } from "../../i18n/contactCTA";

const ContactCTA = () => {
  const navigate = useNavigate();

  const lang = useSelector((state) => state.language.lang);
  const t = contactCTAText[lang];

  const goToAchieverForm = () => {
    navigate("/achievers");
  };
  return (
    <section className="py-24 bg-navy px-6 text-white overflow-hidden flex flex-col items-center justify-center">
      <h2 className="text-2xl md:text-4xl font-heading text-center text-neonYellow animate-neonFlicker">
        {t.title}
      </h2>
      <p className="mt-4 text-lg text-gray-200 text-center">{t.subtitle}</p>

      <div className="mt-10 inline-block" onClick={goToAchieverForm}>
        <div className="heroneon cursor-pointer select-none">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          {t.button}
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
